import moment from 'moment'
export const initialState = {
    orderType: '',
    patientData: {
        therapist: { name: '', email: '' },
        number: '',
        id: '',
        birthdate: undefined,
        lastName: '',
        gender: 'male',
        initials: '',
        orderNumber: '',
        receiveRegion: {name: '', group: ''},
        shippingOption: '',
        otherInstructions: '',
        emergencyOrder: false,
        entryDate: moment(),
        deliveryDate: undefined,
        readyDate: undefined,
        appointmentDate: undefined,
        activeLasts: [{ formattedName: '-' }],
        selectedLast: '-'
    },
    generalAccordion: {
        accordion: true,
        validate: false,
        hasBeenOpened: true
    },
    generalErrors: {
        display: false,
        message: [],
        number: false,
        birthdate: false,
        lastName: false,
        emergencyOrder: false,
        postponeOrder: false,
        gender: false
    }
}
